var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIconMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6937 14.7417H8.30625C3.72656 14.7417 0 18.4741 0 23.0609C0 23.5774 0.421875 23.9999 0.9375 23.9999H23.0625C23.5781 23.9999 24 23.5774 24 23.0609C24 18.4741 20.2734 14.7417 15.6937 14.7417ZM1.94531 22.122C2.4 19.014 5.08125 16.6196 8.31094 16.6196H15.6937C18.9234 16.6196 21.6047 19.014 22.0594 22.122H1.94531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0986C15.6047 13.0986 18.5391 10.1596 18.5391 6.5493C18.5391 2.93897 15.6047 0 12 0C8.39531 0 5.46094 2.93897 5.46094 6.5493C5.46094 10.1596 8.39531 13.0986 12 13.0986ZM12 1.87793C14.5781 1.87793 16.6641 3.96714 16.6641 6.5493C16.6641 9.13146 14.5781 11.2207 12 11.2207C9.42188 11.2207 7.33594 9.13146 7.33594 6.5493C7.34063 3.97183 9.42656 1.88263 12 1.87793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconMob);
export default __webpack_public_path__ + "static/media/user-icon-mob.fef223ca8cc8cc3c181083d68530dd1d.svg";
export { ForwardRef as ReactComponent };